import { render, staticRenderFns } from "./PageLoadingSpinner.vue?vue&type=template&id=2f54a1d2&scoped=true"
import script from "./PageLoadingSpinner.vue?vue&type=script&lang=ts"
export * from "./PageLoadingSpinner.vue?vue&type=script&lang=ts"
import style0 from "./PageLoadingSpinner.vue?vue&type=style&index=0&id=2f54a1d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f54a1d2",
  null
  
)

export default component.exports